import CompLayout from "@/pcomponents/comp/layout/layout";
import CompStuPrescribeCompListArea from "@/pages/comp/edu/comp_stu_prescribe/common/comp_list";

function ListPage() {
  return (
    <CompLayout>
      <CompStuPrescribeCompListArea></CompStuPrescribeCompListArea>
    </CompLayout>
  );
}

export default ListPage;